<template>
  <div class="fz-sidebar__cart">
    <QuickCart />
    <SfDivider class="m-tb-10" />
    <CsvCart />
    <SfDivider class="m-tb-10" />
    <Loader :loading="isCartLoading" :text="$t('Loading Cart...')">
      <div v-if="cart.length">
        <SfHeading :level="4" :title="$t('Items')" class="sf-heading--left m-tb-15" />
        <SfList class="fz-sidebar__cart-list">
          <div class="collected-products">
            <SfListItem>
              <CollectedProduct
                v-for="product in cart"
                :key="product.Product.Id"
                :product="product"
                :isPreview="isPreview"
              />
            </SfListItem>
          </div>
        </SfList>
        <SfDivider class="m-tb-10" />
        <div>
          <div class="fz-sidebar__cart-items">
            {{ $t("Total items:") }}
            <span>{{ cart.length }}</span>
          </div>
          <SfButton class="sf-button--text" @click="clearCart">
            {{ $t("Clear Cart") }}
          </SfButton>
          <Totals v-if="!isPreview" class="totals" />
          <SfButton @click="goTo('/cart')" class="m-b-10 sf-button--full-width sf-button--outline">
            {{ $t("Go to Cart") }}
          </SfButton>
          <SfButton
            :disabled="!isCheckoutAllowed"
            @click="goTo('/checkout')"
            class="sf-button--full-width"
          >
            {{ isCheckoutAllowed ? $t("Go to Checkout") : $t("Loading Cart...") }}
          </SfButton>
          <SfButton @click="goTo('/offer')" class="m-t-10 sf-button--full-width color-primary">
            {{ $t("Create Offer") }}
          </SfButton>
        </div>
      </div>
      <div v-else>
        <SfHeading
          :title="$t('Your shopping cart is empty.')"
          :description="$t(`Dont't hesitate and browse our catalog to find something for You!`)"
          :level="2"
        />
      </div>
    </Loader>
  </div>
</template>
<script>
import {
  SfList, SfHeading, SfButton, SfDivider,
} from '@storefront-ui/vue';
import { Loader } from '@/modules/core';
import QuickCart from '../cart/QuickCart.vue';
import CsvCart from '../cart/CsvCart.vue';
import CollectedProduct from '../CollectedProduct.vue';
import Totals from '../Totals.vue';
import cart from '../../mixins/cart';

export default {
  mixins: [cart],
  components: {
    SfList,
    SfButton,
    SfDivider,
    SfHeading,
    QuickCart,
    CsvCart,
    CollectedProduct,
    Loader,
    Totals,
  },
  data() {
    return {
      isPreview: true,
    };
  },
  created() {
    if (this.isPreview) {
      this.fetchSimpleCart();
    } else {
      this.fetchCart().then(() => {
        this.fetchTotals();
      });
    }
  },
  methods: {
    goTo(path) {
      this.$router.replace(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.fz-sidebar__cart-items {
  margin: var(--spacer-sm) 0;
  text-align: center;
  & > span {
    font-weight: var(--font-medium);
  }
}
.sf-button:first-of-type {
  margin-bottom: var(--spacer-sm);
}

.totals {
  margin: 25px 0;
}
</style>
